
const app = async () => {
  const { initialise } = await import(/* webpackChunkName: "bootstrap" */ './bootstrap');
  const { default: baseSetup } = await import(/* webpackChunkName: "bootstrap" */ './mixins/baseSetup');
  const { createStore } = await import(/* webpackChunkName: "store" */ "./store/store.js");

  const { Vue } = await initialise();
  const store = await createStore(Vue);

  const app = new Vue({
    el: "#app",
    name: "App",
    mixins: [
        baseSetup
    ],
    store,
    components: {
      "product-listing": () => import(/* webpackChunkName: "product-listing" */"./components/ProductListing"),
    }
  });
  return app;
}

import swiper from "./components/swiper";

app().then((vm) => {
  document.querySelectorAll(".swiper-component").forEach(item => {
    swiper.init(item);
  });

  // Handle tabs gracefully as per https://hackernoon.com/removing-that-ugly-focus-ring-and-keeping-it-too-6c8727fefcd2
  function handleFirstTab(e) {
    if (e.keyCode === 9) {
      document.documentElement.classList.add("user-is-tabbing");
      window.removeEventListener("keydown", handleFirstTab);
      window.addEventListener("mousedown", handleMouseDownOnce);
    }
  }

  function handleMouseDownOnce() {
    document.documentElement.classList.remove("user-is-tabbing");
    window.removeEventListener("mousedown", handleMouseDownOnce);
    window.addEventListener("keydown", handleFirstTab);
  }

  window.addEventListener("keydown", handleFirstTab);
});



